import { render, staticRenderFns } from "./RedeploymentApproval.vue?vue&type=template&id=99215a3e&scoped=true"
import script from "./RedeploymentApproval.vue?vue&type=script&lang=js"
export * from "./RedeploymentApproval.vue?vue&type=script&lang=js"
import style0 from "./RedeploymentApproval.vue?vue&type=style&index=0&id=99215a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99215a3e",
  null
  
)

export default component.exports